import byType from './by_type'
import Specsavers from './specsavers'
import Projects from './projects'

export default {
  by_type: byType,
  specsavers: Specsavers,
  projects: Projects,
}
